<template>
  <v-list-item :href="href" target="_blank" rel="noopener noreferrer">
    <v-list-item-icon>
      <v-icon>
        {{ icon }}
      </v-icon>
    </v-list-item-icon>
    <v-list-item-title>
      <span v-text="title" />
    </v-list-item-title>
  </v-list-item>
</template>

<script>
export default {
  name: 'BaseDrawerMenuLink',
  props: {
    icon: {
      type: String,
      required: true,
      note: "The item's image",
    },
    title: {
      type: String,
      required: true,
      note: "The item's label",
    },
    href: {
      type: String,
      required: true,
      note: "The item's external link",
    },
  },
};
</script>
